import { Signal, attachDriver } from 'rwwa-rx-state-machine'
import { TypedRecord, recordify } from 'typed-immutable-record'
import {
  Initialise,
  SelectAcceptor,
  ShowAllRating,
  ShowQuaddieTips,
  ShowSpeedMap,
  ShowTopRating,
} from './signals'

// These enums are referenced in the Giddy Up Bet Type Data Element in DTM. Renaming them will break Analytics unless the changes are made there to match.
export enum ViewType {
  TopRating,
  SpeedMap,
  AllRating,
  QuaddieTips,
}

export interface IViewState {
  currentView: ViewType
  loadingMessage?: string
  raceKey?: string
  acceptorSelected: boolean
}

export interface IViewStateRecord extends TypedRecord<IViewStateRecord>, IViewState {}
const defaultViewState = recordify<IViewState, IViewStateRecord>({
  currentView: ViewType.TopRating,
  raceKey: '',
  acceptorSelected: false,
})

function viewDriver(state = defaultViewState, signal: Signal): IViewStateRecord {
  switch (signal.tag) {
    case ShowTopRating: {
      return state.set('currentView', ViewType.TopRating)
    }

    case ShowAllRating: {
      return state.set('currentView', ViewType.AllRating)
    }

    case ShowSpeedMap: {
      return state.set('currentView', ViewType.SpeedMap)
    }

    case ShowQuaddieTips: {
      return state.set('currentView', ViewType.QuaddieTips)
    }

    case Initialise: {
      return getDefault(state, signal.data.raceKey)
        .set('raceKey', signal.data.raceKey)
        .set('acceptorSelected', false)
    }

    case SelectAcceptor:
      return state.set('acceptorSelected', true)

    default:
      return state
  }
}

function getDefault(state: IViewStateRecord, raceKey: string) {
  if (state.get('currentView') === ViewType.QuaddieTips) {
    if (state.get('raceKey') === raceKey) {
      return state
    } else {
      return state.set('currentView', ViewType.TopRating)
    }
  } else {
    return state
  }
}

export const page$ = attachDriver({ path: 'racingform-page', driver: viewDriver })

// cspell:ignore racingform recordify
